import axios from 'axios'
// #19374
const EXCEL_FILE_NAME_LEN_LIMIT = 180
const LEN_OF_DOT = 1

// #19374
const truncateFileNameIfExceedsLimit = (fileName, limit) => {
  if (fileName.length <= limit) {
    return fileName
  }
  let truncatedFileName = truncateFileNamePreserveAllExtensions(fileName, limit)
  if (truncatedFileName.length <= limit) {
    return truncatedFileName
  }
  truncatedFileName = truncateFileNamePreserveLastExtension(fileName, limit)
  if (truncatedFileName.length <= limit) {
    return truncatedFileName
  }
  return fileName.substring(0, limit)
}
const truncateFileNamePreserveAllExtensions = (fileName, limit) => {
  let fileNameParts = fileName.split('.')
  const lengthOfAllExtensions = fileNameParts.slice(1).join('.').length
  const giveUpBecauseExtensionsAloneAreTooLong = lengthOfAllExtensions >= limit
  if (giveUpBecauseExtensionsAloneAreTooLong) {
    return fileName
  }
  const allowableNonExtensionLength = limit - lengthOfAllExtensions - LEN_OF_DOT
  const truncatedFileNamePart = fileNameParts[0].substring(0, allowableNonExtensionLength)
  fileNameParts.splice(0, 1, truncatedFileNamePart)
  return fileNameParts.join('.')
}

const truncateFileNamePreserveLastExtension = (fileName, limit) => {
  let fileNameParts = fileName.split('.')
  let nonLastExtension = fileNameParts.slice(0, fileNameParts.length - 1).join('.')
  let lastExtension = fileNameParts[fileNameParts.length - 1]
  const giveUpBecauseLastExtensionAloneIsTooLong = lastExtension.length >= limit
  if (giveUpBecauseLastExtensionAloneIsTooLong) {
    return fileName
  }
  const allowableLengthExcludingLastExtension = limit - lastExtension.length - LEN_OF_DOT
  const truncatedNonLastExtension = nonLastExtension.substring(0, allowableLengthExcludingLastExtension)
  return [truncatedNonLastExtension, lastExtension].join('.')
}

export default {
  methods: {
    download(url, fileName, options) {
      fileName = fileName == null ? 'file.xlsx' : truncateFileNameIfExceedsLimit(fileName, EXCEL_FILE_NAME_LEN_LIMIT)
      var params = (options == null || options.params == null) ? {} : options.params
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // important
        params: params,
      }).then((response) => {
        if (response.status == 204) {
          options.noDataCb(response)
          return
        }
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { //for IE
          window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName)
        } else {
          const bloburl = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = bloburl
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
        if (options) {
          options.successful(response)
        }
      }).catch((error) => {
        if (options && options.failedCb) {
          options.failedCb(error)
        }
      })
    },
    downloadByPost(url, requestData, fileName, options) {
      fileName = fileName == null ? 'file.xlsx' : truncateFileNameIfExceedsLimit(fileName, EXCEL_FILE_NAME_LEN_LIMIT)
      var params = (options == null || options.params == null) ? {} : options.params
      axios({
        url: url,
        method: 'POST',
        data: requestData,
        responseType: 'blob', // important
        params: params,
      }).then((response) => {
        if (response.data.type == 'application/json') {
          options.nodataCb(response)
        } else {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) { //for IE
            window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName)
          } else {
            const bloburl = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = bloburl
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
          if (options) {
            options.successful()
          }
        }
      }).catch((error) => {
        if (options && options.failedCb) {
          options.failedCb(error)
        }
      })
    },
  },
  computed: {

  },
}